import { translate } from 'react-switch-lang';
import { Badge, Button, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { Practice } from '../../model/types';

interface DetailPracticeProps {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
  practice: Practice | null;
  t: (key: string) => string;
}

const DetailPractice = ({ isOpen, setIsOpen, practice, t }: DetailPracticeProps) => {
  if (!practice) return null;

  return (
    <Modal isOpen={isOpen} toggle={() => setIsOpen(false)} centered>
      <ModalHeader toggle={() => setIsOpen(false)}>{t('practice.detail_practice')}</ModalHeader>
      <ModalBody>
        <table className="table table-borderless">
          <tbody>
            <tr>
              <th style={{ width: '35%' }}>{t('practice.name')}</th>
              <td>{practice.name}</td>
            </tr>
            <tr>
              <th>{t('practice.description')}</th>
              <td>{practice.description ?? '—'}</td>
            </tr>
            <tr>
              <th>{t('practice.status')}</th>
              <td>
                {practice.active ? (
                  <Badge color="success">{t('practice.active')}</Badge>
                ) : (
                  <Badge color="danger">{t('practice.inactive')}</Badge>
                )}
              </td>
            </tr>
          </tbody>
        </table>

        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '16px' }}>
          <Button color="secondary" outline onClick={() => setIsOpen(false)}>
            {t('practice.close')}
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default translate(DetailPractice);
